export interface HorizontalCellNavigationInput {
  key: string;
  columnIndex: number;
  columnCount: number;
}

export const resolveHorizontalCellNavigation = ({
  key,
  columnIndex,
  columnCount
}: HorizontalCellNavigationInput): number | null => {
  if (key !== 'ArrowLeft' && key !== 'ArrowRight') return null;

  const direction = key === 'ArrowRight' ? 1 : -1;
  const nextColumnIndex = columnIndex + direction;

  if (nextColumnIndex < 0 || nextColumnIndex >= columnCount) return null;

  return nextColumnIndex;
};

export interface CellNavigationInput extends HorizontalCellNavigationInput {
  rowIndex: number;
  rowCount: number;
}

export interface CellNavigationTarget {
  rowIndex: number;
  columnIndex: number;
}

export const resolveCellNavigation = ({
  key,
  rowIndex,
  rowCount,
  columnIndex,
  columnCount
}: CellNavigationInput): CellNavigationTarget | null => {
  if (key === 'ArrowUp' || key === 'ArrowDown') {
    const direction = key === 'ArrowDown' ? 1 : -1;
    const nextRowIndex = rowIndex + direction;

    if (nextRowIndex < 0 || nextRowIndex >= rowCount) return null;

    return {
      rowIndex: nextRowIndex,
      columnIndex
    };
  }

  const nextColumnIndex = resolveHorizontalCellNavigation({ key, columnIndex, columnCount });
  if (nextColumnIndex === null) return null;

  return {
    rowIndex,
    columnIndex: nextColumnIndex
  };
};

export interface TextCursorNavigationInput {
  key: string;
  value: string;
  selectionStart: number | null;
  selectionEnd: number | null;
}

export const shouldPreserveTextCursor = ({
  key,
  value,
  selectionStart,
  selectionEnd
}: TextCursorNavigationInput): boolean => {
  if (key !== 'ArrowLeft' && key !== 'ArrowRight') return false;
  if (selectionStart === null || selectionEnd === null) return false;
  if (selectionStart !== selectionEnd) return false;

  if (key === 'ArrowLeft') return selectionStart > 0;
  return selectionEnd < value.length;
};
